module.exports = __webpack_public_path__ + "img/black-check.ce806eb9.svg";